// eslint-disable-next-line no-restricted-imports
export {
  AlarmClock,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignLeft,
  AppWindow,
  ArrowBigRight,
  ArrowDown,
  ArrowDownToLine,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowRightLeft,
  ArrowRightToLine,
  ArrowUp,
  ArrowUpDown,
  ArrowUpFromLine,
  ArrowUpToLine,
  AudioLines,
  AudioWaveform,
  Bell,
  BellRing,
  Bold,
  Bone,
  BookCopy,
  Box,
  BoxSelect,
  Braces,
  Building2,
  Calendar,
  CalendarClock,
  CalendarFold,
  CalendarX2Icon,
  Check,
  CheckCheck,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsDownUp,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  ChevronsUpDown,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleFadingArrowUp,
  CircleHelp,
  CircleMinus,
  CirclePause,
  CirclePlay,
  CircleStop,
  CircleX,
  ClipboardCheck,
  ClipboardCopy,
  ClipboardEdit,
  ClipboardList,
  ClipboardPaste,
  ClipboardPen,
  Clock,
  CloudDownload,
  CloudUpload,
  Code2,
  Cog,
  ContactRound,
  Copy,
  CopyPlus,
  CornerDownLeft,
  CornerDownRight,
  Database,
  Download,
  Dumbbell,
  Edit,
  Ellipsis,
  EllipsisVertical,
  Equal,
  ExternalLink,
  Eye,
  EyeOff,
  FastForward,
  File,
  FileAudio,
  FileBracesCorner,
  FileCode,
  FileEdit,
  FileExclamationPoint,
  FileInput,
  FileSymlink,
  FileText,
  FileTypeCorner,
  FileUp,
  FileWarning,
  Files,
  Filter,
  Flag,
  FlagTriangleRight,
  FlaskConical,
  Gavel,
  Gem,
  Globe,
  Grip,
  GripVertical,
  Heading1,
  Heading2,
  Heading3,
  HeartHandshake,
  HelpCircle,
  History,
  Home,
  ImagePlus,
  Import,
  Info,
  Italic,
  Languages,
  Layers,
  LayoutDashboard,
  LayoutTemplate,
  Lightbulb,
  Link,
  List,
  ListChecks,
  ListFilter,
  ListOrdered,
  Lock,
  LogOut,
  Mail,
  MapPin,
  MapPinned,
  Maximize2,
  Menu,
  Merge,
  MessageSquare,
  MessageSquarePlus,
  MessageSquareQuote,
  MessageSquareText,
  Mic,
  MicOff,
  Minimize2,
  Minus,
  MinusCircle,
  Monitor,
  MoreHorizontal,
  MoveHorizontal,
  Package,
  PackageMinus,
  PackagePlus,
  Palette,
  Paperclip,
  Pause,
  PauseCircle,
  Pencil,
  PencilLine,
  Phone,
  Pill,
  Play,
  PlayCircle,
  Plus,
  PlusCircle,
  Printer,
  Puzzle,
  RadioTower,
  RefreshCcw,
  RefreshCw,
  Rewind,
  Rocket,
  RotateCcw,
  RotateCw,
  Route,
  Save,
  Scaling,
  Search,
  Send,
  SeparatorHorizontal,
  SeparatorVertical,
  Settings,
  Settings2,
  ShieldCheck,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Square,
  SquareArrowOutUpRight,
  SquareCheckBig,
  SquarePen,
  Squircle,
  Star,
  Stethoscope,
  StopCircle,
  Strikethrough,
  Tablet,
  Tag,
  Text,
  Target,
  ThumbsDown,
  ThumbsUp,
  Trash,
  Trash2,
  TriangleAlert,
  Trophy,
  Type,
  Underline,
  Undo2,
  Unlock,
  Upload,
  User,
  UserCheck,
  UserCog,
  UserPlus,
  UserRoundPlus,
  UserRoundSearch,
  UserSquare,
  Users,
  Volume2,
  Wand,
  WandSparkles,
  Waves,
  X,
  Zap,
} from 'lucide-react';

export { Record } from './icons/Record';
